module.exports = __webpack_public_path__ + "img/phone.4619ef21.png";